export const STAGE = 'scr-prod';
export class ScrEnvironment {

  production = true;

  ngDevMode = false;

  stage = STAGE;
  base = `https://api.usshortcodes.com`;
  ws = `wss://wsapi.usshortcodes.com/ws`;

  productName = 'Short Codes Registry';
  helpbase = 'https://usshortcodes.com/scr';
  mbbase = 'https://usshortcodes.com';
  sdbase = `https://${STAGE}-sd.iconectiv.com`;

  api = {
    scr: {
      apikey: 'kFPKUz2jHZ1tYATs4yNbL8rafejxSghV3h3KUt78'
    }
  };

  timeout = 1800;
  timeoutWarning = 90;

  recaptchaKey = '6LdppkkUAAAAAG6fBqpcKWqavxoHiLlQyJgsKoW1';
  servicedesk = false;
}
